<template>
  <div class="text-18px">
    <MenuAdmin
      v-if="shouldShowAdminMenu()"
      class="mb-4"/>
    <MenuCategories />
    <MenuSeasons />
    <MenuPartners />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

import MenuAdmin from "@/components/menus/MenuAdmin.vue"
import MenuCategories from "@/components/menus/MenuCategories.vue"
import MenuSeasons from "@/components/menus/MenuSeasons.vue"
import MenuPartners from "@/components/menus/MenuPartners.vue"

import { useUserStore } from "@/stores/user";

import { FEATURES } from "@/constants";

@Options({
  components: {
    MenuAdmin,
    MenuCategories,
    MenuSeasons,
    MenuPartners
  }
})
export default class SideMenu extends Vue {
  userStore = useUserStore()

  get hasIptcAccess() {
    return this.userStore.checkFeatureAccess(FEATURES.IPTC)
  }

  shouldShowAdminMenu() {
    return (
      this.userStore.checkFeatureAccess("cart_history") ||
      this.userStore.checkFeatureAccess("users") ||
      this.userStore.checkFeatureAccess("validation") ||
      this.userStore.checkFeatureAccess("upload_history")
    )
  }
}
</script>

<style lang="stylus">

</style>
